import React from "react";
import FitNumber from "../../common/FitNumber";
import { BRAND, STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";
import { formatCount } from "../../../utils/numberFormat";

const ActivityTypeCard = ({ title, count, variant = "default" }) => {
  const borderColors = {
    default: "#ededed",
    pending: STATUS_COLORS.planned,
    approved: BRAND.teal,
    rejected: getPaletteColor(2),
  };
  const borderColor = borderColors[variant] || borderColors.default;
  
  
  return (
    <div>
      <div className="bg-[#f7f7f7] text-white h-28 p-2.5 rounded-3xl border-2 hover:border-teal-300 transition-all duration-300 hover:shadow-md" style={{ borderColor }} >
        <h3 className="text-2xl text-center mt-4 mb-0 text-[#3A3A3A] p-0 font-bold text-balance"> 
          <FitNumber value={count ?? 0} text={formatCount(count ?? 0)} /> 
        </h3>
        <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold"> 
          {title} 
        </h6>
      </div>
    </div>
  );
};

const ApplicationsSection = ({ currentData }) => {

  return (
    <div className="lg:col-span-4">
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Applications ({formatCount(currentData?.total || 0)})
        </h3>
        <div className="grid grid-cols-3 gap-2">
          <ActivityTypeCard
            title="Qualified"
            count={currentData?.qualified || 0}
            variant="approved"
          />
          <ActivityTypeCard
            title="Not Qualified"
            count={currentData?.notQualified || 0}
            variant="rejected"
          />
          <ActivityTypeCard
            title="Pending"
            count={currentData?.pending || 0}
            variant="pending"
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationsSection;